import { TerrainType, FactionType, BattleConfig, TerrainDef } from "@/core/types/battle.types";
import { resolveAsset } from "@/core/utils/common.utils";
import { defineMessage } from "@lingui/core/macro";
// import type { TerrainDef, FactionDef } from "../types/battle.types";

export const HEX_SIZE = 128;
export const ANGLE_RATIO = 0.66;
export const SQRT3 = Math.sqrt(3);

export const HEX_HIGHLIGHT_COLOR = 0xffffff;

export const EFFECTIVE_COUNT = 0.88;

export const IDLE_ANIMATION_DURATION = 0.6;

export const DIFFICULTY = {
  easy_player: { playerDmgMult: 1.4, enemyDmgMult: 1.2 },
  easy_enemy:  { playerDmgMult: 1.0, enemyDmgMult: 0.7 },
  fast:  { playerDmgMult: 1.4, enemyDmgMult: 1.4 },
  normal:      { playerDmgMult: 1.0, enemyDmgMult: 1.0 },
} satisfies Record<string, BattleConfig>;

export const HEX_DIRECTIONS: readonly {q: number, r: number}[] = [
  { q: 1, r: 0 },
  { q: 1, r: -1 },
  { q: 0, r: -1 },
  { q: -1, r: 0 },
  { q: -1, r: 1 },
  { q: 0, r: 1 },
] as const;

export const TERRAINS: Record<TerrainType, TerrainDef> = {
  [TerrainType.Obstacle]: {
    id: TerrainType.Obstacle,
    name: defineMessage({ message: 'Obstacle' }),
    color: "#4b6f44",
    canPatch: false,
    canBeSeed: true,
    moveCost: 999,
    blocksMovement: true,
    blocksLineOfSight: true,
    sprite: resolveAsset('@assets/terrain/plains.png'),
    spriteCols: 4,
    spriteRowY: 0,
    textureSize: 256,
  },

  [TerrainType.Plains]: {
    id: TerrainType.Plains,
    name: defineMessage({ message: 'Plains' }),
    color: "#7c9a4a",
    canPatch: true,
    canBeSeed: false,
    moveCost: 10,
    blocksMovement: false,
    blocksLineOfSight: false,
    sprite: resolveAsset('@assets/terrain/plains.png'),
    spriteCols: 4,
    spriteRowY: 0,
    textureSize: 256,
  },

  [TerrainType.Hill]: {
    id: TerrainType.Hill,
    name: defineMessage({ message: 'Hills' }),
    color: "#9a7c4a",
    canPatch: true,
    canBeSeed: true,
    moveCost: 15,
    evasion: 10,
    powerMult: 1.15,
    blocksMovement: false,
    blocksLineOfSight: false,
    sprite: resolveAsset('@assets/terrain/hill_top.png'),
    spriteCols: 1,
    spriteRowY: 0,
    textureSize: 256,
  },

  [TerrainType.Cliff]: {
    id: TerrainType.Cliff,
    name: defineMessage({ message: 'Cliff' }),
    color: "#6b6b6b",
    canPatch: false,
    canBeSeed: false,
    moveCost: 999,
    blocksMovement: true,
    blocksLineOfSight: true,
    sprite: resolveAsset('@assets/terrain/hill_top.png'),
    spriteCols: 1,
    spriteRowY: 0,
    textureSize: 256,
  },
};
